var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 50,
    height: 50,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.05273,2c-12.71426,-0.02847 -23.05273,10.29219 -23.05273,23v0.02734c0.008,0.552 0.46167,0.99433 1.01367,0.98633c0.553,-0.008 0.99433,-0.46167 0.98633,-1.01367c0,-11.982 10.00205,-21.5997 22.12305,-20.9707c10.606,0.551 19.29666,9.24166 19.84766,19.84766c0.612,11.791 -8.47209,21.57656 -19.99609,22.10156c-0.542,0.025 -0.97461,0.45309 -0.97461,0.99609c0,0.562 0.46434,1.02695 1.02734,1.00195c13.071,-0.576 23.32717,-12.09156 21.82617,-25.60156c-1.173,-10.556 -9.67252,-19.05552 -20.22852,-20.22852c-0.86638,-0.09625 -1.72465,-0.14459 -2.57227,-0.14648zM25,6c-10.493,0 -19,8.507 -19,19c0,10.493 8.507,19 19,19c10.493,0 19,-8.507 19,-19c0,-10.493 -8.507,-19 -19,-19zM24.98438,8.98633h0.0293c0.553,0.008 0.99433,0.46167 0.98633,1.01367v12.17188c0.854,0.302 1.52613,0.97413 1.82813,1.82813h8.17188h0.02734c0.552,0.008 0.99433,0.46167 0.98633,1.01367c-0.008,0.552 -0.46167,0.99433 -1.01367,0.98633h-8.17383c-0.424,1.198 -1.55617,1.999 -2.82617,2c-1.262,-0.005 -2.3865,-0.80028 -2.8125,-1.98828c-0.559,-1.56 0.2525,-3.27694 1.8125,-3.83594v-12.17578c-0.008,-0.552 0.43338,-1.00467 0.98438,-1.01367zM3.375,27.875c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM4.5,31.75c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM6.125,35.25c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM8.5,38.5c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM11.375,41.25c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM14.625,43.375c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM18.25,45c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1zM22.125,45.875c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionEnd);
export default __webpack_public_path__ + "static/media/sessionEnd.ed50c1b6e350d9dfa8aa8654efcdec85.svg";
export { ForwardRef as ReactComponent };